import React from "react";
import { GridColumn } from "@sumprio/ui";
import { EmptyStateIcon } from "@sumprio/ui/icons";

interface EmptyStateIconSlotProps {
  icon?: React.ReactNode;
}

export default function EmptyStateIconSlot({ icon }: EmptyStateIconSlotProps) {
  return (
    <GridColumn span={12} display="flex" justifyContent="center">
      {icon ?? <EmptyStateIcon size="xl" width={120} height={120} />}
    </GridColumn>
  );
}
